<template>
  <div class="select-model" v-show="visible">
    <div class="select-model-mask" @click="close"></div>
    <div class="select-model-container">
      <div class="container-title">
        <img :src="`${imgUrl}/mobile/icons/icon-suite-type-select.png`">
        <span>请选择套房类型</span>
      </div>
      <div class="container-content">
        <ul class="select-menu">
          <li v-for="item in menuList" :key="item.id" :class="{'is-selected':item.isSelected,'is-disable':item.isDisable}" @click="change(item)">
            <div class="menu-title">{{item.title}}</div>
            <img v-if="item.isSelected" class="menu-icon" :src="`${imgUrl}/mobile/icons/icon-checked-blue.png`" />
          </li>
        </ul>
        <div v-if="shipCode !== 'OV'" class="select-menu-btn" @click="suiteTypeToSuiteDetails">
          <div class="inner">
            <img :src="`${imgUrl}/mobile/details/suite/suite_details_icon.png`" />
            <span>礼遇详情</span>
          </div>
        </div>
      </div>
      <div class="select-model-close-btn" @click="close"><span class="">X</span></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SuiteTypeSelectModel",
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    suiteType: {
      type: Object,
      default: null
    },
    disableList: {
      type: Array,
      default: null
    },
    shipCode: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      visible: false,
      imgUrl: process.env.VUE_APP_IMG_URL,
      menuList: [{
        id: 'ALL',
        title: '全部',
        type: null,
        isSelected: true
      },{
        id: 'STAR',
        title: '星际套房（尊享25项礼遇）',
        type: 3,
        isSelected: false,
        isDisable: false
      },{
        id: 'SKY',
        title: '天际套房（尊享17项礼遇）',
        type: 2,
        isSelected: false,
        isDisable: false
      },{
        id: 'SEA',
        title: '海际套房（尊享6项礼遇）',
        type: 1,
        isSelected: false,
        isDisable: false
      }]
    }
  },
  watch: {
    isShow(val) {
      if(val) {
        this.menuList.forEach((r,index)=> {
          r.isSelected = r.id === this.suiteType.id;
          if(index !== 0) {
            r.isDisable = this.disableList.find(value=> value === r.type) === undefined;
          }
        });
      }
      this.visible = val;
    }
  },
  methods: {
    close() {
      this.$emit("close", false);
    },
    change(val) {
      if(!val.isDisable) {
        this.menuList.forEach((row) => {
          row.isSelected = row.id === val.id;
        });
        this.$emit("change", val);
      }
    },
    suiteTypeToSuiteDetails() {
      this.$emit('details-popup',true)
    }
  }
}
</script>

<style lang="less" scoped>
.select-model {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 10001;
  & .select-model-mask {
    background-color: rgba(0,0,0,.4);
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    bottom: 94px;
  }
  & .select-model-container {
    background-color: #fff;
    border-top: 5px solid #FEBC10;
    padding: 22px 20px 13px 20px;
    position: absolute;
    bottom: 0;
    width: 100%;
    & .container-title {
      padding-bottom: 8px;
      margin-bottom: 12px;
      img {
        width: 22px;
        vertical-align: middle;
      }
      span {
        display: inline-block;
        vertical-align: middle;
        font-size: 14px;
        color: #4A90E2;
        letter-spacing: 1px;
        line-height: 22px;
        margin-left: 3px;
      }
    }
    & .container-content {
      margin-top: 12px;
    }

    .select-model-close-btn {
      width: 38px;
      text-align: center;
      height: 34px;
      line-height: 34px;
      position: absolute;
      top: -4px;
      right: -4px;
      background: #FEBC10;
      border-bottom-left-radius: 8px;
      -webkit-border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      -webkit-border-bottom-right-radius: 8px;
      > span {
        display: inline-block;
        color: #fff;
        font-size: 16px;
        -webkit-transform: scale(1.5,1.3);
        -moz-transform: scale(1.5,1.3);
        -ms-transform: scale(1.5,1.3);
        -o-transform: scale(1.5,1.3);
        transform: scale(1.5,1.3);
      }
    }
  }
}
.select-menu {
  & > li {
    height: 50px;
    line-height: 50px;
    font-size: 14px;
    overflow: hidden;
    border-bottom: 1px solid #e3e3e3;
    &.is-selected {
      color: #458de0;
    }
    &.is-disable {
      color: #999999;
    }
    & .menu-title {
      float: left;
      width: 85%;
    }
    & .menu-icon {
      float: right;
      height: 16px;
      margin-top: 17px;
    }
  }
}
.select-menu-btn {
  width: 185px;
  height: 58px;
  border-radius: 58px;
  padding: 6px;
  margin: 15px auto 10px;
  text-align: center;
  border: 1px solid #febc10;
  background-color: #FFFFFF;
  & .inner {
    height: 44px;
    line-height: 44px;
    border-radius: 44px;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #febc10;
    color: #48575a;
    & > img {
      align-items: center;
      height: 27px;
      margin-right: 5px;
    }
  }
}
</style>
